import { Injectable } from '@angular/core';
import * as fs from 'file-saver';
import * as XLSX from 'xlsx';
import * as Excel from 'exceljs';

@Injectable({
  providedIn: 'root'
})
export class ExportService {

  constructor() { }

  fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
  fileExtension = '.xlsx';

  public exportExcel(jsonData: any[], fileName: string): void {

    const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(jsonData);
    const wb: XLSX.WorkBook = { Sheets: { 'data': ws }, SheetNames: ['data'] };
    const excelBuffer: any = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
    this.saveExcelFile(excelBuffer, fileName);
  }

  private saveExcelFile(buffer: any, fileName: string): void {
    const data: Blob = new Blob([buffer], {type: this.fileType});
    fs.saveAs(data, fileName + this.fileExtension);
  }

  public exportExceljs(
    jsonData: any[],
    reportHeading:string,
    subheading:string,
    headerArray:any[],
    fileName: string,
    sheetName:string): void {
    
    const wb  = new Excel.Workbook();
    const ws = wb.addWorksheet(sheetName);
    wb.creator = 'Logistics';
    wb.lastModifiedBy = 'Logistics';
    wb.created = new Date();
    wb.modified = new Date();

    // report heading
    ws.addRow([]);
    ws.mergeCells('A1:' + this.numToAlpha(headerArray.length)+'1');
    ws.getCell('A1').value = reportHeading;
    ws.getCell('A1').alignment = {horizontal:'center'};
    ws.getCell('A1').font = {size:15,bold:true};
    
    // sub heading
    ws.addRow([]);
    ws.mergeCells('A2:' + this.numToAlpha(headerArray.length)+'2');
    ws.getCell('A2').value = subheading;
    ws.getCell('A2').alignment = {horizontal:'center'};
    ws.getCell('A2').font = {size:12,bold:true};
    
    //header columns 
    console.log(headerArray);
    const headercolumns = headerArray.map(x=>x.name);
    console.log(headercolumns);
    headercolumns.unshift('Sl No')
    const headerrow = ws.addRow(headercolumns);
    headerrow.eachCell((cell,index) =>{
      cell.border = { top:{style:'thin'},left:{style:'thin'},bottom:{style:'thin'},right:{style:'thin'} }
      cell.font = { size:12,bold:true }
      ws.getColumn(index).width = headercolumns[index-1].length <20?20:headercolumns[index-1].length;
    })
    // Get all columns from json array
    jsonData.forEach((column) =>{
      const eachRow = [];
      for(const key in column){
        eachRow.push(column[key]);
      }
      ws.addRow(eachRow);
    })

    wb.xlsx.writeBuffer().then((data: ArrayBuffer) =>{
      const blob = new Blob([data], {type: this.fileType})
      fs.saveAs(blob,fileName+ this.fileExtension);
    });
  }


  // numToAlpha
  private numToAlpha(num:number) {
    let alpha = '';
    for (;num>=0; num = parseInt((num/26).toString(),10)-1) {
      alpha = String.fromCharCode(num%26+0x41) + alpha;
    }
    return alpha;
  }
}
